import { FlagsComponentRouter, FlagsSingleton } from 'flags'

import { isSiteSelectionV2 } from 'utils/productHelpers'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: [
    'feature_LEARN-20108-ms-site-selection',
    'feature_LEARN-20164-k5-site-selection',
  ],
  OnComponent,
  OffComponent,
  flagsChecker: FlagsSingleton.checkAtLeastOneFlagTrue,
  onCondition: (_, subscribedFlags) => isSiteSelectionV2(_, subscribedFlags),
})

export default FlagToggler
